import OrganizationBanks from './OrganizationBanks';

export default OrganizationBanks;
